import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <>
      <nav className="app-header navbar navbar-expand bg-body">
        <div className="container-fluid">
          {/* Start Navbar Links */}
          <ul className="navbar-nav">
            <li className="nav-item"></li>
          </ul>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown user-menu">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                <FontAwesomeIcon icon={faEllipsisVertical} />
              </a>
              <ul
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end"
                style={{
                  minWidth: "120px", // <-- Fix width
                  width: "120px", // <-- Force narrow width
                  right: 0,
                  left: "auto",
                  marginTop: "8px", // move down slightly
                  padding: "5px 8px", // tighter spacing
                }}
              >
                <li className="user-footer">
                  <button
                    onClick={handleLogout}
                    className="btn btn-default btn-flat float-end"
                  >
                    Sign out
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
